import { render, staticRenderFns } from "./incomestatementComponent.vue?vue&type=template&id=378743ff&scoped=true&"
import script from "./incomestatementComponent.vue?vue&type=script&lang=js&"
export * from "./incomestatementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378743ff",
  null
  
)

export default component.exports